import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../src/components/layout/MainLayout";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";
import Swal from "sweetalert2";
import AnxietyList from "./Phase-04/Anxiety/AnxietyList";
import { 
    fetchAnxietyAssessments, 
    deleteAnxietyAssessment 
} from "../store/slices/anxietySlice";

const Anxieties = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { anxietyAssessments, isLoading, error } = useSelector((state) => state.anxiety);

    // Fetch anxiety assessments on mount
    useEffect(() => {
        dispatch(fetchAnxietyAssessments());
    }, [dispatch]);

    // Mock permissions - set to false if you want to test restricted view
    const canCreate = true;
    const canEdit = true;
    const canDelete = true;

    const handleAdd = () => navigate("/phase04/anxiety/add");

    const handleEdit = (id) => {
        const assessment = anxietyAssessments.find(a => a.id === id);
        navigate(`/phase04/anxiety/edit/${id}`, { state: { assessment } });
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This BAI assessment will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            dispatch(deleteAnxietyAssessment(id))
                .unwrap()
                .then(() => {
                    Swal.fire("Deleted!", "Anxiety Form Deleted Successfully.", "success");
                })
                .catch((err) => {
                    Swal.fire("Error!", err || "Failed to delete", "error");
                });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <AnxietyList
                            anxietyAssessments={anxietyAssessments}
                            isLoading={isLoading}
                            error={error}
                            onAddAnxiety={canCreate ? handleAdd : null}
                            onEditAnxiety={canEdit ? handleEdit : null}
                            onDeleteAnxiety={canDelete ? handleDelete : null}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Anxieties;
